import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, debounceTime } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_PRATICA_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storePraticaListAction,
} from '../../data.action';
import { filler } from '../../../../../utils/utils';
import { selectAnagraficaList, selectPraticaList } from '../../data.selector';

const retrievePraticaListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_PRATICA_LIST),
    debounceTime(20),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_PRATICA_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, state]) => {
      return concat(
        of(setLoaders({ praticaLoader: true })),
        of(setListConfigAction({ pratica: body })),
        defer(() =>
          from(
            request({ path: `pratica/list`, method: httpMethods.POST, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }

              // lazy load
              if (body?.append) {
                const currentList = selectPraticaList(state)?.result;
                return {
                  total: p?.total,
                  result: [...(currentList ?? []), ...p?.result],
                };
              }

              return { total: p?.total, result: [...p?.result, ...filler] };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_PRATICA_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storePraticaListAction(data))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_PRATICA_LIST}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ praticaLoader: false }))
      );
    })
  );

export default retrievePraticaListEpic;
